<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>{{ title }}</v-card-title>

      <v-card-actions>
        <v-icon class="close" @click="close()">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="">
        <v-row no-gutters>
          <v-col cols="3">
            <p class="overline text-uppercase">Person</p>
            <p class="mt-n3" v-if="person">
              <router-link :to="'/people/' + person.personId">{{ person | fullName }}</router-link>
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline text-uppercase">Personummer</p>
            <p class="mt-n3" v-if="person && person.personalNumber">
              {{ person.personalNumber | formatPnr }}
            </p>
          </v-col>
          <v-col cols="3">
            <p class="overline">MOBILNUMMER</p>
            <p class="mt-n3" v-if="person && person.mobilephone">
              <a :href="`tel:${person.mobilephone}`"> {{ person.mobilephone }}</a>
            </p>
          </v-col>
          <v-col cols="3" class="ml-n6"
            ><p class="overline">E-POSTADRESS</p>
            <p class="mt-n3" v-if="person && person.email">
              <a :href="`mailto:${person.email}`"> {{ person.email }}</a>
            </p>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6">
            <template v-if="!editProfession">
              <p class="overline text-uppercase">Yrke</p>
              <div class="d-flex mb-4">
                <p class="mt-n3">{{ getProfessionNameById(professionId) }}</p>
                <!-- <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editProfession = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn> -->
              </div>
            </template>
            <v-select
              class="mr-4"
              v-else
              outlined
              v-model="professionId"
              :items="
                basicProfessions.map(o => {
                  return {id: o.id, text: o.name}
                })
              "
              item-text="text"
              item-value="id"
              label="Yrke"
              :rules="[rules.required]"
            ></v-select>

            <!-- Education types -->

            <template v-if="!editEducationTypes">
              <p class="overline text-uppercase">UTBILDNINGTYP</p>
              <div class="d-flex mb-4">
                <p
                  class="mt-n3"
                  v-if="
                    find(educationTypes, {id: educationTypeId}) &&
                    find(educationTypes, {id: educationTypeId}).name != 'Okänd'
                  "
                >
                  {{
                    find(educationTypes, {id: educationTypeId})
                      ? find(educationTypes, {id: educationTypeId}).name
                      : 'Ej angivet.'
                  }}
                </p>
                <p class="mt-n3 grey-text font-italic" v-else>
                  Ej angivet.
                </p>
                <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editEducationTypes = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn>
              </div>
            </template>
            <v-select
              class="mr-4"
              v-else
              outlined
              v-model="educationTypeId"
              :items="
                educationTypes.map(o => {
                  return {id: o.id, text: o.name}
                })
              "
              item-text="text"
              item-value="id"
              label="Utbildningtyp"
              :rules="[rules.required]"
            ></v-select>

            <template v-if="!editSchoolName">
              <p class="overline text-uppercase">Utbildningsgivare</p>
              <div class="d-flex mb-4">
                <p class="mt-n3" v-if="schoolName">{{ schoolName }}</p>
                <p class="mt-n3 grey-text font-italic" v-else>
                  Ej angivet.
                </p>
                <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editSchoolName = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn>
              </div>
            </template>
            <v-text-field
              class="mr-4"
              v-else
              outlined
              v-model="schoolName"
              label="Utbildningsgivare"
              :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <!-- PROFESSIONS ORIENTATIONS-->
          <v-col cols="6">
            <div v-if="hasProfessionOrientations(professionId)">
              <template v-if="!editMachines">
                <p class="overline text-uppercase">Maskinslag</p>
                <div class="d-flex mb-4">
                  <p class="mt-n3" v-if="displayMachinesForModeShow">
                    {{ displayMachinesForModeShow ? displayMachinesForModeShow : 'Inga Maskinslag ' }}
                  </p>
                  <p class="mt-n3" v-else>{{ orientationsSelected ? orientationsSelected : 'Inga Maskinslag' }}</p>
                  <!-- <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editMachines = true" text>
                    <v-icon small>$sl-edit</v-icon>
                  </v-btn> -->
                </div>
              </template>

              <!-- ADD MACHINES CHECHBOX HERE -->
              <v-select
                v-else
                v-model="selectedOrientationIds"
                item-disabled="defaultIncluded"
                item-text="name"
                item-value="id"
                label="Maskinslag"
                :items="oSelect"
                outlined
                multiple
              >
              </v-select>
            </div>
            <div v-else>
              <template>
                <p class="overline text-uppercase">Maskinslag</p>
                <div class="d-flex mb-4">
                  <p class="mt-n3 grey-text font-italic">Inga Maskinslag.</p>
                </div>
              </template>
            </div>
            <template v-if="!editProgram">
              <p class="overline text-uppercase">Utbildning</p>
              <div class="d-flex mb-4">
                <p class="mt-n3" v-if="program">{{ program }}</p>
                <p class="mt-n3 grey-text font-italic" v-else>
                  Ej angivet.
                </p>
                <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editProgram = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn>
              </div>
            </template>
            <v-text-field v-else outlined v-model="program" label="Utbildning" :rules="[rules.required]"></v-text-field>
            <!-- end date -->
            <template v-if="!editExamYear">
              <p class="overline text-uppercase">Examensår</p>
              <div class="d-flex">
                <p class="mt-n3" v-if="examYear">{{ examYear }}</p>
                <p class="mt-n3 grey-text font-italic" v-else>
                  Ej angivet.
                </p>
                <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editExamYear = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn>
              </div>
            </template>
            <v-text-field v-else outlined v-model="examYear" label="Examensår" :rules="[rules.required]"></v-text-field>
          </v-col>
        </v-row>

        <!-- DOCUMENTS -->
        <div class="overline">BILAGOR</div>
        <template v-if="documents && documents.length > 0">
          <div v-for="(doc, index) in documents" :key="index">
            <a v-if="doc && doc.fileName && doc.internalFileName" @click="getDocument(doc)">{{ doc.fileName }}</a>
          </div>
        </template>
        <p class="mt-0 grey-text font-italic" v-else>
          Bilagor saknas.
        </p>

        <!-- Courses -->
        <h6 class="text-uppercase mt-6 mb-4">kvalificeringstid</h6>
          <v-row no-gutters>
            <v-col cols="6">              
              <template v-if="!editStartDate">
                <p class="overline text-uppercase">Startdatum</p>
                <div class="d-flex mb-4">
                  <p class="mt-n3" v-if="startDate && startDate!=''">{{startDate | date}}</p>
                  <p class="mt-n3 grey-text font-italic" v-else>
                      Ej angivet.
                  </p>
                  <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editStartDate = true" text>
                    <v-icon small>$sl-edit</v-icon>
                  </v-btn>    
                </div>
              </template>
              <DatePicker v-else
                  ref="startDate"                                    
                  :clearable="true"
                  label="Startdatum"
                  v-model="startDate"
                  class="pr-4"
                  outlined
                />
            </v-col>
            <v-col cols="6">
              <template v-if="!editTimeLength">
              <p class="overline text-uppercase">Längd</p>
              <div class="d-flex mb-4">
                <p class="mt-n3" v-if="qualificationLength && qualificationLength>0">{{qualificationLength}} {{ qualificationLength==1 ? 'månad' : 'månader' }}</p>
                <p class="mt-n3 grey-text font-italic" v-else>
                  Ej angivet.
                </p>
                <v-btn v-show="showPen" class="ml-n6 mt-n7" @click="editTimeLength = true" text>
                  <v-icon small>$sl-edit</v-icon>
                </v-btn>
              </div>
            </template>
            <v-select
              class="mr-4"
              v-else
              outlined
              v-model="qualificationLength"
              :items="timesLengths" 
              item-text="text"
              item-value="value"
              label="Längd"              
            ></v-select>
            </v-col>
          </v-row>
        <template v-if="propCourses && propCourses.length > 0">
          <h6 class="text-uppercase mt-6 mb-4">Gymnasiekurser för det valda yrket med krav på godkänt betyg</h6>
          <v-expansion-panels multiple v-model="panel">
            <v-expansion-panel v-for="(groupname, index) in Object.keys(appCourses)" :key="index">
              <v-expansion-panel-header class="subtitle-1 text-uppercase" expand-icon="$sl-arrow-down">
                <b>{{ groupname }}</b>
              </v-expansion-panel-header>
              <v-expansion-panel-content v-for="(item, index2) in appCourses[groupname]" :key="index2">
                <v-row no-gutters>
                  <v-col cols="12">
                    <span class="subtitle-1">{{ item.courseName }}</span>
                    <p class="subtitle-2 grey-text">{{ item.credit | filterCredit }} {{ item.courseCode }}</p>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <!-- checkbox list for approvment -->

        <h6 class="mt-4 text-uppercase">Checklista för godkännande</h6>
        <ul>
          <li>Namn och dess stavning stämmer överens med intyg och betyg.</li>
          <li>Personnummer stämmer överens med intyg och betyg.</li>
          <li>Personen har godkänt i de kurser som krävs eller motsvarande yrkeserfarenhet.</li>
        </ul>

        <v-row class="mt-8">
          <v-col cols="6">
            <p class="overline text-uppercase">Godkänd av</p>

            <!-- <router-link :to="'/people/' + person.id">{{ person | fullName }}</router-link> -->
            <p
              class="mt-n3"
              v-if="
                propEducation &&
                propEducation.basicEducationCertificate &&
                propEducation.basicEducationCertificate.createdBy
              "
            >
              {{ propEducation.basicEducationCertificate.createdBy | fullName }} ({{ propEducation.createdAt | date }})
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>
              Ej godkänd.
            </p>
          </v-col>

          <v-col cols="6">
            <p class="overline">BEKRÄFTAD  AV</p>
            <p
              class="mt-n3"
              v-if="
                propEducation &&
                propEducation.basicEducationCertificate &&
                propEducation.basicEducationCertificate.approvedBy
              "
            >
              {{ propEducation.basicEducationCertificate.approvedBy | fullName }} ({{
                propEducation.basicEducationCertificate.approvedAt | date
              }})
            </p>
            <p class="mt-n3 grey-text font-italic" v-else>
              Ej bekräftad.
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-end mt-n4">
        <v-btn color="secondary" @click="close"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
        <!--  <v-btn v-if="mode === 'show'" @click="updateEducation()"> <v-icon>$sl-check</v-icon>Spara</v-btn> -->
        <v-btn color="secondary" v-if="mode === 'approve'" @click="deleteEducation()">
          <v-icon>$sl-dislike</v-icon>Neka</v-btn
        >
        <v-btn v-if="mode === 'approve'" @click="saveClick()"> <v-icon>$sl-like</v-icon>Bekräfta</v-btn>
        <v-btn v-if="mode === 'create'" @click="saveClick()"> <v-icon>$sl-check</v-icon>Godkänn</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import API from '@/services/api.js'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import sortBy from 'lodash/sortBy'
import get from 'lodash/get'
import uniqBy from 'lodash/uniqBy'
import map from 'lodash/map'
import cloneDeep from 'lodash/cloneDeep'
import filter from 'lodash/filter'
import {RulesMixin} from '@/components/mixins'
import groupBy from 'lodash/groupBy'
import {forEach} from 'lodash'
import fileDownload from 'js-file-download'
import DatePicker from '@/components/common/DatePicker'
import date from 'sugar/date'

const SugarDate = require('sugar/date')
// @group Education
// EducationModal component
export default {
  name: 'EducationModal',
  mixins: [RulesMixin],
  components: {
    DatePicker
  },
  props: {
    // approve/create
    mode: {
      type: String,
      default: ''
    },
    // default title
    title: {
      type: String,
      default: 'UTFÄRDA GU-INTYG'
    },
    // Application id for create an certificate
    propId: {
      type: Number
    },
    // Person object with a default value
    person: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },    
    // Profession with a default value
    propProfession: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },

    // Education with a default value
    propEducation: {
      type: Object,
      // Object or array defaults must be returned from
      // default empty
      default: function () {
        return {}
      }
    },
    // Selected courses from application object or person
    propCourses: {
      type: Array,
      // default empty
      default: []
    },
    // Selected documents from application object or person
    documents: {
      type: Array,
      // default empty
      default: function () {
        return []
      }
    },
    // Selected professionOrientations from application object or person
    propMachines: {
      type: Array,
      // default empty
      default: function () {
        return []
      }
    },
    // Selected professionOrientations from application object or person
    selMachines: {
      type: Array,
      // default empty
      default: function () {
        return []
      }
    }
  },
  data: () => ({
    valid: true,
    editForm: false,
    showPen: false,
    timesLengths: [],
    qualificationLength: -1,
    editProfession: false,
    editStartDate: false,
    editTimeLength: false,
    editEducationLength: false,
    editProgram: false,
    editEducationTypes: false,    
    editExamYear: false,
    editSchoolName: false,
    editMachines: false,    
    panel: [0],
    oSelect: [],
    orientationsSelected: '',

    educationTypes: [],
    professionId: null,
    endDate: null,
    startDate: null,
    examYear: null,
    program: null,
    schoolName: null,
    educationTypeId: null,
    selectedOrientationIds: []
  }),
  watch: {
    propEducation() {
      this.init()
    },
    mode() {
      //if ((this.mode && this.mode === 'approve') || this.mode === 'show') {
      if (this.mode === 'show') {
        this.editForm = false
        this.showPen = false
        this.init()
      } else {
        this.editForm = true
        this.showPen = true
      }
    },
    professionId: function (newProfessionId) {
      this.getMachines(newProfessionId)
      if(this.editProfession==true)
        this.getDefaultQualificationTime(newProfessionId)          

    }
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('basic', [
      'basicProfessions',
      'getProfessionById',
      'getProfessionNameById',
      'hasProfessionOrientations',
      'basicMachines',
      'getMachineNameById', 'getQualificationLengthItems'
    ]),
    appCourses() {
      return groupBy(
        this.propCourses.map(pc => pc.course),
        'groupName'
      )
    },    
    displayMachinesForModeShow() {
      const nonEmptyArray = function(a) {return Boolean(a && Array.isArray(a) && a.length > 0)}
      let prof = this.getProfessionById(this.propProfession.id)
      try {
        if (prof && nonEmptyArray(prof.machineOrientations) && nonEmptyArray(this.selMachines)) {
          return filter(prof.machineOrientations, o => this.selMachines.includes(o.id)).map(m => m.name).join(', ')
        }
      } catch(e) {
        // nada 
      }
      return ''
    }
  },

  created() {
    if (this.mode && this.mode === 'show') {
      this.editForm = false
      this.showPen = false
    } else {
      this.editForm = true
      this.showPen = true
    }
    this.init()
  },
  methods: {
    ...mapActions('application', ['setSelectedApplication']),
    //- Stunt to make imported funktion a this.func to be used in template
    sortBy: sortBy,
    find: find,

    init() {         
      this.timesLengths=this.getQualificationLengthItems

      this.listEducationTypes()
      this.professionOrientations = [...this.propMachines]
      if (this.propProfession && this.propProfession.id) {
        this.professionId = this.propProfession.id
        this.initProfessionId = this.propProfession.id
      }
      if (this.person && this.person.employmentDate)
        this.startDate = new Date(this.person.employmentDate).toISOString().substr(0, 10)
      else
        this.startDate = new Date().toISOString().substr(0, 10)
      let months=36
            
      // if(this.propEducation && this.propEducation.qualificationTimeLength && this.propEducation.qualificationTimeLength>0) {
      //     months = this.propEducation.qualificationTimeLength                    

      if(this.propEducation && this.propEducation.startDate && this.propEducation.endDate) {
      { // this.monthDiff(this.propEducation.startDate, this.propEducation.endDate)
          months = this.monthDiff(new Date(this.propEducation.startDate), new Date(this.propEducation.endDate))
      }
        
      if(this.timesLengths.length>0 && this.timesLengths.find(m => m.value==months))
          this.qualificationLength = this.timesLengths.find(m => m.value==months).value
      }        
      else {                          
          this.getDefaultQualificationTime(this.professionId)          
      }                               
    
      if (this.propEducation) {                
        
        // else if(this.propEducation.endDate && this.propEducation.startDate)
        // {
        //   let months
        //   //months = SugarDate.Date(this.propEducation.endDate, this.propEducation.startDate).monthsSince()
        //   months = this.propEducation.qualificationTimeLength ? this.propEducation.qualificationTimeLength : 36
        //   if(this.timesLengths.length>0 && this.timesLengths.find(m => m.value==months))
        //     this.qualificationLength= this.timesLengths.find(m => m.value==months).value          
        // }

        this.educationId = this.propEducation.id
        this.educationTypeId = this.propEducation.educationTypeId
        this.schoolName = this.propEducation.extendedInfo ? this.propEducation.extendedInfo.schoolName : null
        this.program = this.propEducation.extendedInfo ? this.propEducation.extendedInfo.program : null
        this.examYear = this.propEducation.extendedInfo ? this.propEducation.extendedInfo.examYear : null
        this.endDate = this.propEducation.endDate ? this.propEducation.endDate : null
        this.startDate = this.propEducation.startDate ? this.propEducation.startDate : this.person?.employmentDate,
        this.selectedOrientationIds = this.propEducation.extendedInfo
          ? this.propEducation.extendedInfo.professionOrientations
          : []
      }
                   
    },
    getDefaultQualificationTime(profId) {
      if(!(this.person && this.person.id && profId))
        return
    
      API.getDefaultQualificationTime(profId, this.person.id)
        .then(res => {     
          if(res.data){
          let months = 36
          if(res.data.qualificationTimeLength)          
            months=res.data.qualificationTimeLength            

          if(this.timesLengths && this.timesLengths.length>0 && this.timesLengths.find(m => m.value==months))
            this.qualificationLength = this.timesLengths.find(m => m.value==months).value
            //return "hejsan"
          }
        })
        .catch(error => {
          console.log('error-', error)
        })      
    },
    monthDiff(d1, d2) {
      var months
      months = (d2.getFullYear() - d1.getFullYear()) * 12
      months -= d1.getMonth()
      months += d2.getMonth()
      return months <= 0 ? 0 : months
    },
    close() {      
      this.$emit('close')
      this.editProfession = false
      this.editEducationTypes = false
      this.editProgram = false
      this.editExamYear = false
      this.editSchoolName = false
      this.editMachines = false
      this.editStartDate=false
      this.editTimeLength=false
      this.init()
      console.log("close")
      
    },
    getMachines(newProfessionId) {
      this.selectedOrientationIds = []
      this.oSelect = []
      this.orientationsSelected = ''
      this.editMachines = false

      if (this.professionId != this.initProfessionId && this.hasProfessionOrientations(newProfessionId)) {
        let prof = this.getProfessionById(newProfessionId).machineOrientations
        let sortProf = sortBy(prof, [
          function (o) {
            return o.isDefaultIncluded ? 0 : 1
          }
        ])
        this.selectedOrientationIds = filter(sortProf, ['isDefaultIncluded', true]).map(o => o.id)
        sortProf.forEach(e => {
          this.oSelect.push({id: e.id, name: e.name, defaultIncluded: e.isDefaultIncluded})
        })
        this.editMachines = true
      } else {
        this.professionOrientations = [...this.propMachines]
        this.professionOrientations.forEach(e => {
          this.selectedOrientationIds.push(e.professionMachineOrientationId)
          if (this.orientationsSelected != '') this.orientationsSelected += ', '
          this.orientationsSelected += e.professionMachineOrientation.name
        })

        let prof = this.getProfessionById(this.initProfessionId).machineOrientations
        let sortProf = sortBy(prof, [
          function (o) {
            return o.isDefaultIncluded ? 0 : 1
          }
        ])

        sortProf.forEach(e => {
          this.oSelect.push({id: e.id, name: e.name, defaultIncluded: e.isDefaultIncluded})
        })
      }
    },
    listEducationTypes() {
      API.listEducationTypes()
        .then(res => {
          this.educationTypes = res.data
        })
        .catch(error => {
          console.log('error:', error)
        })
    },
    saveClick(){
//this.educationTypeId = this.propEducation.educationTypeId      

//return 
//this.schoolName = this.propEducation.extendedInfo ? this.propEducation.extendedInfo.schoolName : null
      
      let saveProfessionOrientations = []
      var today = new Date()
      let edited=false
      let endDate = null
      let startDate=this.$options.filters.date(today)
      let qualificationTimeLength=0
      if(this.startDate!='')
        startDate=this.startDate
              
      if (this.qualificationLength!='' && this.qualificationLength>0) {
        endDate=SugarDate.Date(startDate).addMonths(this.qualificationLength).format("{yyyy}-{MM}-{dd}").raw;
        qualificationTimeLength=this.qualificationLength
      }
            
      if(this.mode=='approve' && this.propEducation){
        // if(this.professionId != this.propProfession.id)
        //   edited=true
        if(this.educationTypeId != this.propEducation.educationTypeId)
          edited=true
        else if(this.schoolName != this.propEducation.extendedInfo.schoolName)
          edited=true
        else if(this.propEducation.extendedInfo) {
          if(this.propEducation.extendedInfo.professionOrientations && this.propEducation.extendedInfo.professionOrientations && isEqual(Array(this.propEducation.extendedInfo.professionOrientations), Array(this.selectedOrientationIds))==false) {                                    
            edited=true
          }
          else if (this.schoolName != this.propEducation.extendedInfo.schoolName) {
            edited=true
          }
          else if (this.program != this.propEducation.extendedInfo.program) {
            edited=true
          }
          else if (this.examYear != this.propEducation.extendedInfo.examYear) {
            edited=true
          }
          else if(this.qualificationLength != this.propEducation.qualificationTimeLength)
             edited=true
          else if(this.startDate != this.propEducation.startDate)
            edited=true
        } 
          
      }
      let data = {} 

      if(edited==true || this.mode=='create'){
        data = {
          //professionId: this.professionId,
          startDate: startDate,
          endDate: endDate,
          qualificationTimeLength: qualificationTimeLength,
          educationTypeId: this.educationTypeId,
          extendedInfo: {
            professionOrientations: this.selectedOrientationIds,
            schoolName: this.schoolName,
            program: this.program,
            examYear: this.examYear
          }
        }
      }
  //    console.log("data::", data)
//return
      this.selectedOrientationIds.forEach(element => {
        saveProfessionOrientations.push({applicationId: this.propId, professionMachineOrientationId: element})
      })

      if(this.mode === 'approve')
      {
        this.approveEducation(data, saveProfessionOrientations)    
      }
      else if(this.mode === 'create')
      {
        this.createEducation(data, saveProfessionOrientations)    
      }
      //this.saveEducation()
    },
    approveEducation(data, saveProfessionOrientations) {
      if (!this.educationId) return      

      API.approveEducation(this.educationId, {data: data}).then(() => {
        this.$events.fire('showInfo', 'Godkännande av grundutbildning bekräftat.')   
        this.close()          
        this.$emit('deleted-education')
      })
    },    

    createEducation(data, saveProfessionOrientations) {                       
        if (!this.propId) return
      //console.log("data::", data)
      API.createEducation(this.propId, {data: data})
        .then(res => { 
          this.$events.fire('showInfo', 'Grundutbildning godkänd.')
          //this.updateApplication(this.propId, saveProfessionOrientations)
          this.close()          
          this.$emit('deleted-education')
        })
        .catch(error => {
          console.log('error :>> ', error)
        })
    },
    updateApplication(id, saveProfessionOrientations){
      if(!(this.professionId && this.professionId>0))
        return

      API.updateApplication(id, {
        data: {professionId: this.professionId, saveProfessionOrientations}
      })
      .then(response => {
        if (response.data) {
         // this.refreshApplication()
          this.close()          
          this.$emit('deleted-education')
        }              
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
      //this.refreshApplication()

    },
    refreshApplication() {
      if (!this.propId) return
      API.getApplication(this.propId)
        .then(response => {
          //$emit('certificate',response.data)"
          this.$refs.form.reset()
          this.setSelectedApplication(response.data)
          this.close()          
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    async deleteEducation() {
      const eduApplication = get(this, 'propEducation.application', {})

      if (eduApplication.id && eduApplication.stateId === 11) {
        this.$emit('refuse', eduApplication.id)
        return
      }

      if (!this.educationId) return
      const res = await this.$dialog.confirm({
        text: '',
        title: 'Vill du verkligen neka detta intyg?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'NEKA', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      API.denyEducation(this.educationId, {data: { message: 'Ångrad' }})
      .then(res => {
        this.$events.fire('showInfo', 'Godkännande nekat.')
        this.$refs.form.reset()
        this.$emit('deleted-education')
        this.$emit('close')
      })
      .catch(error => {
        console.log('error :>> ', error)
      })
    },

    getDocument(doc) {
      API.getApplicationDocuments(doc.id)
        .then(response => {
          fileDownload(response.data, doc.fileName, response.headers['content-type'])
        })
        .catch(error => {
          console.log('get document error, ' + doc, error)
        })
    }
  }
}
</script>

<style>
</style>
